import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import StudentCard from './StudentCard';
import '../../../assets/css/teacherMaster.css';
import { useNavigate } from 'react-router-dom';
import AddStudentMasterDialog from './AddStudentMaster';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import { FilterMatchMode } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { InputSwitch } from 'primereact/inputswitch';
import { FileUpload } from "primereact/fileupload";
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import { apiBase } from '../../../utils/config';
import ResetPassword from '../../ResetPassword/ResetPassword';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import NoLoginDialog from '../../NoLoginDialog/NoLoginDialog';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Paginator } from 'primereact/paginator';
import moment from 'moment';

const STUDENT_EXPORT_FIELDS = [
    { key: 'rollNo', label: 'Roll No' },
    { key: 'studentId', label: 'Student ID' },
    { key: 'grNo', label: 'GR No' },
    { key: 'name', label: 'Name' },
    { key: 'firstName', label: 'First Name' },
    { key: 'surname', label: 'Surname' },
    { key: 'fatherName', label: 'Father Name' },
    { key: 'motherName', label: 'Mother Name' },
    { key: 'gender', label: 'Gender' },
    { key: 'dob', label: 'DOB' },
    { key: 'bloodGroup', label: 'Blood Group' },
    { key: 'aadhar', label: 'Aadhar No' },
    { key: 'house', label: 'House' },
    { key: 'className', label: 'Class' },
    { key: 'section', label: 'Section' },
    { key: 'board', label: 'Board' },
    { key: 'medium', label: 'Medium' },
    { key: 'classFullName', label: 'Class (Full)' },
    { key: 'academicYear', label: 'Academic Year' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'currentAddress', label: 'Current Address' },
    { key: 'permanentAddress', label: 'Permanent Address' },
    { key: 'fatherMobile', label: 'Father Mobile' },
    { key: 'fatherEmail', label: 'Father Email' },
    { key: 'motherMobile', label: 'Mother Mobile' },
    { key: 'motherEmail', label: 'Mother Email' },
    { key: 'status', label: 'Status' },
    { key: 'isLogin', label: 'Login Enabled' },
];

const DEFAULT_EXPORT_FIELDS = ['rollNo', 'studentId', 'name', 'gender', 'className', 'section', 'phone', 'email'];

const EXPORT_GENDER_OPTIONS = [{ label: 'Male', value: 'male' }, { label: 'Female', value: 'female' }];
const EXPORT_NATIONALITY_OPTIONS = [{ label: 'Indian', value: 'indian' }, { label: 'Other', value: 'other' }];
const EXPORT_YESNO_OPTIONS = [{ label: 'Yes', value: 'true' }, { label: 'No', value: 'false' }];
const EXPORT_STATUS_OPTIONS = [{ label: 'Active', value: 'Active' }, { label: 'Inactive', value: 'Inactive' }];

// Student Status defaults to Active (User.Status). "Clear filters" keeps that default.
const EMPTY_EXPORT_FILTERS = {
    Gender: '', ClassId: [], House: '', Status: 'Active', QuotaId: '',
    Nationality: '', IsPhStatus: '', PhCategoryId: '', IsTFW: '', BloodGroup: '',
};

const StudentMaster = () => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const [selectAll, setSelectAll] = useState(false);
    const [securityUserID, setSecurityUserID] = useState("");
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [visible, setVisible] = useState(false);
    const debounceRef = useRef(null)
    const [studentsList, setStudentsList] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [viewMode, setViewMode] = useState('list');
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [isPasswordReset, setIsPasswordReset] = useState(false);
    const [isNoLoginChange, setIsNoLoginChange] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ClassName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Board: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Medium: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [updatedStatus, setUpdatedStatus] = useState('');
    const [isStatusConfirmation, setIsStatusConfirmation] = useState(false);
    const fileUploadRef = useRef(null);
    const [isUploadVisible, setIsUploadVisible] = useState(false);
    const [updatedPassword, setUpdatedPassword] = useState('');
    const [updatedPhone, setUpdatedPhone] = useState('');
    const [updatedEmail, setUpdatedEmail] = useState('');
    const [prefillPhone, setPrefillPhone] = useState('');
    const [prefillEmail, setPrefillEmail] = useState('');
    const noLoginDialogRef = useRef(null);
    const [accessList, setAccessList] = useState({});
    const [classList, setClassList] = useState([]);
    const [classId, setClassId] = useState([]);
    const [deleteType, setDeleteType] = useState('Single');
    const [totalRecords, setTotalRecords] = useState(0);
    const [loadedPages, setLoadedPages] = useState(1);
    const [selectedYear, setSelectedYear] = useState('');
    const [academicYearList, setAcademicYearList] = useState([]);
    const [pageAccess, setPageAccess] = useState({});
    const [schoolId, setSchoolId] = useState("");
    const [isExportVisible, setIsExportVisible] = useState(false);
    const [exportFields, setExportFields] = useState(DEFAULT_EXPORT_FIELDS);
    const [exportFilters, setExportFilters] = useState({ ...EMPTY_EXPORT_FILTERS });
    const [houseOptions, setHouseOptions] = useState([]);
    const [casteOptions, setCasteOptions] = useState([]);
    const [phCategoryOptions, setPhCategoryOptions] = useState([]);
    const [bloodOptions, setBloodOptions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                Loader.show();
                const loginData = CommonConfig.loginData();
                const accessData = CommonConfig.getUserAccess('Student Master');
                setPageAccess(accessData);
                setSecurityUserID(loginData?._id);
                await getFinancialYearData(loginData);
                await GetConfigurationData(loginData?._id);
            } catch (error) {
                Loader.hide();
                console.error('Error in useEffect:', error);
            } finally {
                Loader.hide();
            }
        };
        fetchData();
    }, []);

    const getFinancialYearData = async (userData) => {
        const effectiveId = userData?.UserRole === 'Teacher' ? (userData?.CreatedBy || userData?._id) : userData?._id;
        setSchoolId(effectiveId);
        loadExportMasters(effectiveId);
        const years = await CommonConfig.getFinancialYears(effectiveId);
        setAcademicYearList(years);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
        const selectedClassId = userData?.SelectedClassfilter ? userData?.SelectedClassfilter?.split(',') : [];
        setClassId(selectedClassId);
        setSelectedYear(selectedAcYear ?? currentYear?.value);
        await GetClassList(effectiveId, selectedAcYear ?? currentYear?.value);
        await GetStudentsList(userData?._id, 1, selectedAcYear ?? currentYear?.value, userData?.SelectedClassfilter ? userData?.SelectedClassfilter : '', effectiveId);
    }

    useEffect(() => {
        if (!Array.isArray(studentsList) || !Array.isArray(selectedStudents)) return;

        const allSelected = studentsList?.length > 0 &&
            studentsList?.every(s => selectedStudents?.some(sel => sel?._id === s?._id));

        setSelectAll(allSelected);
    }, [selectedStudents, studentsList]);


    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetPasswordConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setAccessList(res?.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
            debounceRef.current = null;
        }

        setFilters({ ...filters, global: { value: value, matchMode: FilterMatchMode.CONTAINS } });
        setGlobalFilterValue(value);

        if (value.trim() === "") {
            triggerSearch("");
            return;
        }

        debounceRef.current = setTimeout(() => {
            triggerSearch(value);
        }, 800);
    };

    const onKeyDown = (e) => {
        if (e.key === "Enter") {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
            triggerSearch(globalFilterValue);
        }
    };

    const triggerSearch = async (value) => {
        if (!CommonConfig.isEmpty(value)) {
            const filteredStudentsList = studentsList
                .filter(x =>
                    x?.Name?.toLowerCase()?.includes(globalFilterValue.toLowerCase()) ||
                    x?.Email?.includes(globalFilterValue) ||
                    x?.Phone?.includes(globalFilterValue)
                )
            if (filteredStudentsList.length > 0) {
                setStudentsList(filteredStudentsList);
            } else {
                await GetSearchedStudentsList(securityUserID, value, selectedYear);
            }
        } else {
            await GetStudentsList(securityUserID, 1, selectedYear, classId.length ? (classId.length > 1 ? classId.join(',') : classId[0]) : '');
        }
    };

    const onPageChange = async (e) => {
        setFirst(e.first);
        setRows(e.rows);

        const endIndex = e.first + e.rows;
        const alreadyLoaded = loadedPages * 50;
        if (endIndex > alreadyLoaded && alreadyLoaded < totalRecords) {
            await GetStudentsList(securityUserID, loadedPages + 1, selectedYear, classId.length ? (classId.length > 1 ? classId.join(',') : classId[0]) : '')
        }
    };

    const onCancel = async () => {
        setVisible(false);
        await GetStudentsList(securityUserID, 1, selectedYear, classId.length ? (classId.length > 1 ? classId.join(',') : classId[0]) : '');
    }

    const toggleActiveStatus = (id, status) => {
        setDeleteId(id);
        setUpdatedStatus(status === true ? 'Active' : 'Inactive');
        setIsStatusConfirmation(true);
    };

    const GetStudentsList = async (id, pageno, financialId, selectedCassId, schoolIdOverride) => {
        try {
            let data = {
                UserID: id,
                SchoolId: schoolIdOverride || schoolId || id,
                page: pageno,
                limit: 50,
                FinancialYearId: financialId,
                ClassId: selectedCassId || '',
                ScopeBy: 'Teaching'
            }
            Loader.show();
            await api.post(APIConstant.path.getStudentDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    let filteredData = res?.data?.sort((a, b) => parseInt(a?.RollNo) - parseInt(b?.RollNo));
                    if (pageno === 1) {
                        setStudentsList(filteredData);
                    } else {
                        setStudentsList(prev => [...prev, ...filteredData]);
                    }
                    if (!filteredData?.length) {
                        setClassId([]);
                    }
                    setTotalRecords(res?.totalRecord);
                    setLoadedPages(pageno);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetSearchedStudentsList = async (id, searchText, financialId, selectedClassId) => {
        try {
            let data = {
                UserID: id,
                SchoolId: schoolId || id,
                SearchText: searchText,
                FinancialYearId: financialId,
                ClassId: selectedClassId || '',
                ScopeBy: 'Teaching'
            }
            Loader.show();
            await api.post(APIConstant.path.getSearchedStudentDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    let filteredData = res?.data?.sort((a, b) => parseInt(a?.RollNo) - parseInt(b?.RollNo));
                    setStudentsList(filteredData);
                    setTotalRecords(filteredData.length);
                    setLoadedPages(1);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center'>
                    {pageAccess?.ViewAccess &&
                        <Button icon="icon-view tailer-icon" className='e-btn p-my-0 p-mx-2' onClick={() => navigate('/viewEdit-student-master', { state: { userId: rows?._id, isEdit: false } })} />}
                    {pageAccess?.EditAccess && <Button icon="pi pi-pencil" className="e-sction-btn p-m-0" onClick={() => {
                        navigate('/viewEdit-student-master', { state: { userId: rows?._id, isEdit: true } })
                    }} />}
                    {pageAccess?.DeleteAccess &&
                        <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-m-2" onClick={(e) => {
                            setIsDeleteConfirmation(true);
                            setDeleteId(rows._id);
                        }} />}
                    {pageAccess?.EditAccess && (
                        <>
                            <InputSwitch
                                checked={rows?.Status === 'Active' ? true : false}
                                onChange={(e) => {
                                    toggleActiveStatus(rows._id, e.value);
                                }}
                                className="p-ml-1 p-mt-1"
                            />
                            {!rows?.IsNoLogin && <Button icon="pi pi-ban" className="e-sction-btn p-m-0 p-m-2" onClick={(e) => {
                                setIsNoLoginChange(true);
                                setDeleteId(rows._id);
                                setPrefillPhone(rows?.Phone || '');
                                setPrefillEmail(rows?.Email || '');
                                setUpdatedPhone(rows?.Phone || '');
                                setUpdatedEmail(rows?.Email || '');
                            }} />}
                            {rows?.IsNoLogin && accessList?.IsStudent &&
                                <Button icon="pi pi-key" className="e-sction-btn p-m-0 p-m-2" onClick={(e) => {
                                    setIsPasswordReset(true);
                                    setDeleteId(rows._id);
                                }} />}
                        </>)}
                </div>
            </React.Fragment>
        );
    };

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteStudent()}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleResetClose = (type) => {
        if (type === 'Password') {
            setIsPasswordReset(false)
        } else {
            setIsNoLoginChange(false);
        }
        setDeleteId('');
    };

    const handleDelete = (id) => {
        setIsDeleteConfirmation(true);
        setDeleteId(id);
    };

    const handleResetDialog = (id, type) => {
        if (type === 'Password') {
            setIsPasswordReset(true)
        } else {
            setIsNoLoginChange(true);
        }
        setDeleteId(id);
    };

    const GetClassList = async (id, academicYearId) => {
        try {
            const loginData = CommonConfig.loginData();
            let data = {
                UserID: loginData?._id,
                SchoolId: id,
                FinancialYearId: academicYearId,
                ScopeBy: 'Teaching'
            }
            await api.post(APIConstant.path.getClassList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setClassList(res?.data?.filter(x => x?.Status === 'Active')?.map(x => ({
                        ...x,
                        label: `${x?.ClassName}-${x?.SectionFullName}-${x?.MediumName}-${x?.Board}`,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const renderStatusFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseStatus}
            />
            <Button
                label="Save"
                className="btn-text-action-primary"
                onClick={(e) => UpdateStatus()}
            />
        </div>
    );

    const renderResetFooter = (type) => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={() => {
                    if (type === 'Password') {
                        handleResetClose('Password');
                    } else {
                        handleResetClose('NoLogin');
                    }
                }}
            />
            <Button
                label="Save"
                className="btn-text-action-primary"
                onClick={(e) => {
                    if (type === 'Password') {
                        UpdatePassword();
                    } else {
                        UpdateLoginDetails();
                    }
                }
                }
            />
        </div>
    );

    const handleCloseStatus = () => {
        setIsStatusConfirmation(false)
    };

    const handlePasswordChange = (password) => {
        setUpdatedPassword(password);
    };

    const handleNoLoginChange = (phone, email, password) => {
        setUpdatedPhone(phone);
        setUpdatedEmail(email);
        setUpdatedPassword(password);
    };

    const UpdateStatus = async () => {
        try {
            let data = {
                id: deleteId,
                Status: updatedStatus
            }
            await api.post(APIConstant.path.updateStudentStatus, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Student status updated successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    await GetStudentsList(securityUserID, 1, selectedYear, classId.length ? (classId.length > 1 ? classId.join(',') : classId[0]) : '');
                }
                handleCloseStatus();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                handleCloseStatus();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const UpdatePassword = async () => {
        try {
            let data = {
                id: deleteId,
                Password: updatedPassword
            }
            await api.post(APIConstant.path.updatePassword, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Student password updated successfully' });
                    setDeleteId('');
                    setUpdatedPassword('');
                    await GetStudentsList(securityUserID, 1, selectedYear, classId.length ? (classId.length > 1 ? classId.join(',') : classId[0]) : '');
                }
                handleResetClose();
            }).catch(err => {
                Loader.hide();
                Toast.error({ message: err?.message });
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const DeleteStudent = async () => {
        try {
            let data;
            if (deleteType == 'Single') {
                data = {
                    id: deleteId
                };
            } else {
                const deletedID = selectedStudents?.map((y) => y?._id);
                data = {
                    ids: deletedID
                }
            }
            await api.post(APIConstant.path.deleteStudent, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Student deleted successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetStudentsList(securityUserID, 1, selectedYear, classId.length ? (classId.length > 1 ? classId.join(',') : classId[0]) : '');
                }
                handleClose();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                handleClose();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    // Validation lives in the dialog so errors render inline under each field
    // (toasts fire behind the modal and aren't visible).
    const validate = () => noLoginDialogRef.current?.validate?.() ?? false;

    const UpdateLoginDetails = async (e) => {
        if (validate(e)) {
            try {
                let data = {
                    id: deleteId,
                    Email: updatedEmail ?? '',
                    Password: updatedPassword,
                    Phone: updatedPhone ?? '',
                    IsNoLogin: true,
                };
                Loader.show();
                await api.post(APIConstant.path.AddUpdateUser, data).then(async response => {
                    let res = response;
                    if (res.success) {
                        Toast.success({ message: 'Changes updated' });
                        Loader.hide();
                        handleResetClose('NoLogin');
                        await GetStudentsList(securityUserID, 1, selectedYear, classId.length ? (classId.length > 1 ? classId.join(',') : classId[0]) : '');
                    } else {
                        Toast.error({ message: res.message });
                        Loader.hide();
                    }
                }).catch((err) => {
                    Toast.error({ message: err });
                    Loader.hide();
                });
            } catch (err) {
                console.log(err);
                Loader.hide();
                handleResetClose('NoLogin');
                catchResponse(err);
            }
        }
    };

    const onChangeClass = async (e) => {
        try {
            const selectedClassIds = e.value;
            setClassId(selectedClassIds);
            const formatedClassId = selectedClassIds.length ? (selectedClassIds.length > 1 ? selectedClassIds.join(',') : selectedClassIds[0]) : '';
            await GetStudentsList(securityUserID, 1, selectedYear, formatedClassId);
            let data = {
                id: securityUserID,
                SelectedClassfilter: formatedClassId
            };
            await api.post(APIConstant.path.AddUpdateUser, data).then(async response => {
                let res = response;
                if (res.success) {
                    const loginData = CommonConfig.loginData();
                    loginData.SelectedClassfilter = formatedClassId;
                    localStorage.setItem('ERPLoginData', JSON.stringify(loginData));
                }
            })
                .catch((err) => {
                    console.error(err);
                    Toast.error({ message: 'Failed to update user details' });
                    Loader.hide();
                });
        } catch (err) {
            console.log(err);
            Toast.error({ message: 'An error occurred' });
            Loader.hide();
            catchResponse(err);
        }
    };

    const handleDownloadSampleFile = async () => {
        try {
            Loader.show();
            const loginData = CommonConfig.loginData();
            const payload = {
                accountType: loginData?.AccountType,
                userType: loginData?.UserType,
                userId: loginData?.UserRole === 'Teacher' ? loginData?.CreatedBy : securityUserID,
            };
            const res = await api.post(APIConstant.path.GenerateStudentSample, payload);
            if (res.success && res?.sampleFileUrl) {
                const downloadUrl = `${apiBase}${res.sampleFileUrl}`;
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", downloadUrl.split('/').pop());
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                Loader.hide();
            } else {
                Loader.hide();
                Toast.error({ message: res?.message || 'Failed to download sample file' });
            }
        } catch (err) {
            Loader.hide();
            Toast.error({ message: err?.message || 'Failed to download sample file' });
            catchResponse(err);
        }
    };

    const handleUploadVisible = () => {
        setIsUploadVisible(false)
    };

    const loadExportMasters = async (id) => {
        try {
            const [houseRes, casteRes, phRes, bloodRes] = await Promise.all([
                api.post(APIConstant.path.getHouseList, { UserID: id }),
                api.post(APIConstant.path.getCasteList, { UserID: id }),
                api.post(APIConstant.path.getPhCategoryList, { UserID: id }),
                api.post(APIConstant.path.getBloodList, { UserID: id }),
            ]);
            if (houseRes?.success) setHouseOptions((houseRes.data || []).filter(x => x?.Status === 'Active').map(x => ({ label: x?.HouseName, value: x?._id })));
            if (casteRes?.success) setCasteOptions((casteRes.data || []).map(x => ({ label: x?.CasteName, value: x?._id })));
            if (phRes?.success) setPhCategoryOptions((phRes.data || []).map(x => ({ label: x?.PhCategoryName, value: x?._id })));
            if (bloodRes?.success) setBloodOptions((bloodRes.data || []).map(x => ({ label: x?.BloodName, value: x?._id })));
        } catch (err) { console.log(err); }
    };

    const setExportFilter = (key, value) => {
        setExportFilters((prev) => ({ ...prev, [key]: value }));
    };

    const toggleExportField = (key) => {
        setExportFields((prev) => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
    };

    const toggleAllExportFields = (checked) => {
        setExportFields(checked ? STUDENT_EXPORT_FIELDS.map(f => f.key) : []);
    };

    const handleExportStudents = async () => {
        if (!exportFields.length) {
            Toast.error({ message: 'Please select at least one field to export' });
            return;
        }
        try {
            setIsExportVisible(false);
            Loader.show();
            const formatedClassId = classId.length ? (classId.length > 1 ? classId.join(',') : classId[0]) : '';
            const filterClassId = exportFilters.ClassId?.length ? exportFilters.ClassId.join(',') : formatedClassId;
            const orderedFields = STUDENT_EXPORT_FIELDS.filter(f => exportFields.includes(f.key)).map(f => f.key);
            const data = {
                UserID: securityUserID,
                SchoolId: schoolId || securityUserID,
                FinancialYearId: selectedYear,
                ClassId: filterClassId,
                SearchText: globalFilterValue || '',
                Fields: orderedFields,
                ScopeBy: 'Teaching',
                Gender: exportFilters.Gender || '',
                House: exportFilters.House || '',
                Status: exportFilters.Status || '',
                QuotaId: exportFilters.QuotaId || '',
                Nationality: exportFilters.Nationality || '',
                PhCategoryId: exportFilters.PhCategoryId || '',
                BloodGroup: exportFilters.BloodGroup || '',
                IsPhStatus: exportFilters.IsPhStatus || '',
                IsTFW: exportFilters.IsTFW || '',
            };
            if (selectedStudents?.length > 0) {
                data.StudentIds = selectedStudents.map(s => s?._id);
            }
            const res = await api.post(APIConstant.path.ExportStudents, data);
            if (res.success && res?.fileUrl) {
                const downloadUrl = `${apiBase}${res.fileUrl}`;
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", downloadUrl.split('/').pop());
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                Toast.success({ message: res?.message || 'Students exported successfully' });
                setIsExportVisible(false);
            } else {
                Toast.error({ message: res?.message || 'Failed to export students' });
            }
            Loader.hide();
        } catch (err) {
            Loader.hide();
            Toast.error({ message: err?.message || 'Failed to export students' });
            catchResponse(err);
        }
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="">
                <div className="p-d-flex p-ai-baseline p-jc-between">
                    <div className="flex flex-column text-left ml-3">
                        <p> {file.name} </p>
                        <small>{new Date().toLocaleDateString()}</small>
                    </div>
                </div>
                <Tag value={props.formatSize} severity="warning" className="e-uplod-box" />
                <div className='p-d-flex p-ai-center p-jc-center'>
                    <Button type="button" icon="pi pi-times" className="p-d-flex p-ai-center p-jc-center p-button-outlined p-button-rounded p-button-danger ml-auto p-m-0" onClick={() => onTemplateRemove(file, props.onRemove)} />
                </div>
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Drag and Drop Image Here
                </span>
            </div>
        );
    };

    const onTemplateUpload = async (e) => {
        const uploadedFile = e.files[0];
        if (!uploadedFile) return;

        try {
            Loader.show();
            const loginData = CommonConfig.loginData();
            const formData = new FormData();
            formData.append("file", uploadedFile);
            formData.append("filename", uploadedFile?.name);
            formData.append("accountType", loginData?.AccountType);
            formData.append("userType", loginData?.UserType);
            formData.append("userId", loginData?.UserRole === 'Teacher' ? loginData?.CreatedBy : securityUserID);
            await api.post(APIConstant.path.ImportStudents, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(async (response) => {
                    let res = response;
                    if (res.success) {
                        Loader.hide();
                        if (res?.skippedFileUrl) {
                            var downloadUrl = `${apiBase}${res?.skippedFileUrl}`;
                            const link = document.createElement("a");
                            link.href = downloadUrl;
                            link.setAttribute("download", downloadUrl.split('/').pop());
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                        handleUploadVisible();
                        Toast.success({ message: res?.message });
                        await getFinancialYearData(loginData);
                    } else {
                        Loader.hide();
                        if (res?.skippedFileUrl) {
                            var downloadcatchUrl = `${apiBase}${res?.skippedFileUrl}`;
                            const link = document.createElement("a");
                            link.href = downloadcatchUrl;
                            link.setAttribute("download", downloadcatchUrl.split('/').pop());
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }
                        Toast.error({ message: res.message });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    Toast.error({ message: err?.message });
                    Loader.hide();
                });

        } catch (error) {
            Loader.hide();
            const errorMessage = error.response?.data?.message || "File upload failed.";
            Toast.error({ message: errorMessage });
            catchResponse(error);
        }
    };

    const onTemplateRemove = (file, callback) => {
        callback();
    };

    const handleSelectStudent = (student) => {
        setSelectedStudents((prev) => {
            const exists = prev?.some(s => s?._id === student?._id);
            if (exists) {
                return prev?.filter(s => s?._id !== student?._id);
            } else {
                return [...prev, student];
            }
        });
    };

    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-rounded p-button-outlined p-m-0' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-success p-button-rounded p-button-outlined p-m-0' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-danger p-button-rounded p-button-outlined p-m-0' };

    return (
        <div className='wayment-owner-dashboard et-students-page'>
            <div className="heading-area p-px-5 p-d-flex p-ai-center p-jc-between">
                <div className="et-title-wrap">
                    <h2>Students Directory</h2>
                    <div className="et-subtitle">
                        {(totalRecords || 0).toLocaleString('en-IN')} students
                        {(() => {
                            const y = academicYearList?.find(a => a?._id === selectedYear);
                            return (y?.StartDate && y?.EndDate)
                                ? ` · Academic Year ${moment(y.StartDate).format('YYYY')}-${moment(y.EndDate).format('YY')}`
                                : '';
                        })()}
                    </div>
                </div>
                <div className="et-head-actions">
                    {pageAccess?.ViewAccess &&
                        <Button icon="pi pi-file-excel" onClick={() => setIsExportVisible(true)} className="e-h-btn" />}
                    {pageAccess?.AddAccess &&
                        <Button icon="pi pi-download" onClick={handleDownloadSampleFile} className=" e-h-btn" />}
                    {pageAccess?.AddAccess &&
                        <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisible(true)} />}
                </div>
            </div>
            <div className="et-kpis">
                <div className="et-kpi">
                    <div className="et-kpi-ic et-kpi-ic--navy"><i className="pi pi-users" /></div>
                    <div><b>{(totalRecords || 0).toLocaleString('en-IN')}</b><span>Total Students</span></div>
                </div>
                <div className="et-kpi">
                    <div className="et-kpi-ic et-kpi-ic--green"><i className="pi pi-check-circle" /></div>
                    <div><b>&mdash;</b><span>Active</span></div>
                </div>
                <div className="et-kpi">
                    <div className="et-kpi-ic et-kpi-ic--blue"><i className="pi pi-user-plus" /></div>
                    <div><b>&mdash;</b><span>New this term</span></div>
                </div>
                <div className="et-kpi">
                    <div className="et-kpi-ic et-kpi-ic--orange"><i className="pi pi-clock" /></div>
                    <div><b>&mdash;</b><span>Fee Pending</span></div>
                </div>
            </div>
            <div className='e-student-master-table e-reset-password'>
                <div className="et-toolbar">
                    <div className="searchbar-area e-searchbar-area et-toolbar-search">
                        <i className="pi pi-search" />
                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange}
                            onKeyDown={onKeyDown} placeholder="Search by name, ID, phone…" />
                    </div>
                    <div className="et-toolbar-actions">
                        <MultiSelect id="className" className='id-g-badge-child e-student-selector' value={classId} options={classList} onChange={(e) => onChangeClass(e)} placeholder="Select Class" display="chip" filter />
                        {viewMode === 'card' && pageAccess?.DeleteAccess && <Checkbox inputId="selectAll" checked={selectAll} onChange={(e) => {
                            setSelectAll(e.checked);
                            if (e.checked) {
                                setSelectedStudents(studentsList);
                            } else {
                                setSelectedStudents([]);
                            }
                        }} />}
                        <Button
                            icon={viewMode === 'card' ? 'pi pi-bars' : 'pi pi-th-large'}
                            className="e-h-btn"
                            onClick={() => setViewMode(viewMode === 'card' ? 'list' : 'card')}
                        />
                        {pageAccess?.AddAccess &&
                            <Button icon="pi pi-upload" onClick={(e) => setIsUploadVisible(true)} className="e-h-btn" />}
                        {pageAccess?.DeleteAccess && selectedStudents.length > 0 &&
                            <Button icon={'pi pi-trash'} className="e-h-btn" onClick={() => { setDeleteType('Multi'); handleDelete(''); }} />}
                    </div>
                </div>
                <div className={viewMode === 'card' ? 'teacher-grid' : 'teacher-list'}>
                    {viewMode === 'card' ? (
                        <>
                            {studentsList.slice(first, first + rows)
                                .map(student => (
                                    <StudentCard
                                        key={student._id}
                                        student={student}
                                        handleDelete={handleDelete}
                                        toggleActiveStatus={toggleActiveStatus}
                                        handleResetDialog={handleResetDialog}
                                        AccessList={accessList}
                                        selectedStudents={selectedStudents}
                                        onSelectStudent={handleSelectStudent}
                                        pageAccess={pageAccess}
                                    />
                                ))
                            }
                        </>
                    ) : (
                        <DataTable
                            value={studentsList.slice(first, first + rows)}
                            selection={selectedStudents}
                            onSelectionChange={(e) => setSelectedStudents(e.value)}
                            dataKey="_id"
                            selectionMode="multiple"
                            paginator
                            lazy
                            rows={rows}
                            first={first}
                            totalRecords={totalRecords}
                            filters={filters}
                            filterDisplay="menu"
                            responsiveLayout="scroll"
                            paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                            rowsPerPageOptions={[5, 10, 20]}
                            currentPageReportTemplate="Showing {first}-{last} of {totalRecords} students"
                            onPage={onPageChange}
                            className='custom-table'
                            scrollHeight='flex'
                            size='small'
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />
                            <Column
                                header="Student"
                                body={(row) => {
                                    const initials = (row?.Name || '').split(' ').filter(Boolean).slice(0, 2).map(n => n[0]?.toUpperCase()).join('') || '?';
                                    return (
                                        <div className="et-stu">
                                            <div className="et-stu-av">
                                                <span>{initials}</span>
                                                {row?.ProfilePhotoUrl
                                                    ? <img src={`${apiBase}/UserProfilePic/${row.ProfilePhotoUrl}`} alt="" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                                                    : null}
                                            </div>
                                            <div className="et-stu-tx">
                                                <b>{row?.Name}</b>
                                                <span className="et-stu-email">{row?.Email ? row.Email : <em className="et-stu-noemail">No email added</em>}</span>
                                                {row?.StudentId ? <span className="et-stu-id">{row?.StudentId}</span> : null}
                                            </div>
                                        </div>
                                    );
                                }}
                            />
                            <Column field="ClassFullName" header="Class" />
                            <Column field="RollNo" header="Roll No" style={{ width: '90px' }} />
                            <Column field="Phone" header="Phone" />
                            <Column
                                header="Status"
                                body={(row) => (
                                    <span className={`et-spill ${row?.Status === 'Active' ? 'et-spill--green' : 'et-spill--gray'}`}>
                                        {row?.Status === 'Active' ? 'Active' : 'Inactive'}
                                    </span>
                                )}
                            />
                            <Column
                                body={actionBodyTemplate}
                                header="Action"
                                headerClassName='e-template-action'
                                bodyClassName='e-template-action'
                                style={{ width: '200px' }} />
                        </DataTable>
                    )}
                </div>
                {viewMode === 'card' ? (
                    <div className="et-card-pager">
                        <Paginator
                            first={first}
                            rows={rows}
                            totalRecords={totalRecords}
                            rowsPerPageOptions={[5, 10, 20]}
                            onPageChange={onPageChange}
                            template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first}-{last} of {totalRecords} students"
                        />
                    </div>
                ) : null}
            </div>
            <Dialog
                header="Add Student Master"
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
                style={{ width: "80vw" }}
            >
                <AddStudentMasterDialog onCancel={onCancel} financialYearId={selectedYear} academicYearList={academicYearList} />

            </Dialog>
            <Dialog
                visible={isPasswordReset}
                onHide={() => handleResetClose('Password')}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Reset Password</span>
                    </div>
                }
                footer={renderResetFooter('Password')}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <ResetPassword onPasswordChange={handlePasswordChange} />
            </Dialog>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
            <Dialog
                visible={isStatusConfirmation}
                onHide={handleCloseStatus}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Status Update</span>
                    </div>
                }
                footer={renderStatusFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div>
                    <p>
                        Are you sure you want to update status?
                    </p>
                </div>
            </Dialog>
            <Dialog
                visible={isUploadVisible}
                onHide={handleUploadVisible}
                header="Upload Excel"
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '500px', minHeight: '480px', maxHeight: '480px', }}
            >
                <div>
                    <div className='p-d-fle p-ai-center p-jc-between p-w-100'>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-choose-btn" content="Choose" position="bottom" />
                        </div>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-upload-btn" content="Upload" position="bottom" />
                        </div>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-cancel-btn" content="Clear" position="bottom" />
                        </div>
                        <FileUpload ref={fileUploadRef} name="file" accept=".xlsx" multiple={false} customUpload={true} uploadHandler={onTemplateUpload} headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate} chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
                    </div>
                </div>
            </Dialog>
            <Dialog
                visible={isNoLoginChange}
                onHide={() => handleResetClose('NoLogin')}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Change to Login</span>
                    </div>
                }
                footer={renderResetFooter('NoLogin')}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <NoLoginDialog ref={noLoginDialogRef} key={deleteId} onLoginChange={handleNoLoginChange} initialPhone={prefillPhone} initialEmail={prefillEmail} />
            </Dialog>
            <Dialog
                visible={isExportVisible}
                onHide={() => setIsExportVisible(false)}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Download Student Data</span>
                    </div>
                }
                footer={
                    <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
                        <Button label="Cancel" className="btn-text-action-secondary" onClick={() => setIsExportVisible(false)} />
                        <Button label="Download" icon="pi pi-file-excel" className="btn-text-action-primary" onClick={handleExportStudents} disabled={!exportFields.length} />
                    </div>
                }
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '640px' }}
            >
                <div className="e-export-dialog">
                    <p style={{ margin: '0 0 12px', fontSize: '14px', color: '#6B7794' }}>
                        {selectedStudents?.length > 0
                            ? `Exporting ${selectedStudents.length} selected student(s)${Object.values(exportFilters).some(v => Array.isArray(v) ? v.length : v) ? ' matching the filters below' : ''}.`
                            : `Exporting all ${(totalRecords || 0).toLocaleString('en-IN')} student(s) matching the filters below.`}
                    </p>
                    <div style={{ marginBottom: '12px' }}>
                        <div className="p-d-flex p-ai-center p-jc-between" style={{ marginBottom: '6px' }}>
                            <span style={{ fontWeight: 600, fontSize: '13px' }}>Filters</span>
                            <span style={{ fontSize: '12px', color: '#3b82f6', cursor: 'pointer' }} onClick={() => setExportFilters({ ...EMPTY_EXPORT_FILTERS })}>Clear filters</span>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
                            <MultiSelect value={exportFilters.ClassId} options={classList} onChange={(e) => setExportFilter('ClassId', e.value)} placeholder="Class" display="chip" filter showClear className="p-w-100" />
                            <Dropdown value={exportFilters.Gender} options={EXPORT_GENDER_OPTIONS} onChange={(e) => setExportFilter('Gender', e.value)} placeholder="Gender" showClear filter className="p-w-100" />
                            <Dropdown value={exportFilters.House} options={houseOptions} onChange={(e) => setExportFilter('House', e.value)} placeholder="House" showClear filter className="p-w-100" />
                            <Dropdown value={exportFilters.Status} options={EXPORT_STATUS_OPTIONS} onChange={(e) => setExportFilter('Status', e.value)} placeholder="Student Status" showClear className="p-w-100" />
                            <Dropdown value={exportFilters.QuotaId} options={casteOptions} onChange={(e) => setExportFilter('QuotaId', e.value)} placeholder="Admission Category" showClear filter className="p-w-100" />
                            <Dropdown value={exportFilters.Nationality} options={EXPORT_NATIONALITY_OPTIONS} onChange={(e) => setExportFilter('Nationality', e.value)} placeholder="Nationality" showClear filter className="p-w-100" />
                            <Dropdown value={exportFilters.IsPhStatus} options={EXPORT_YESNO_OPTIONS} onChange={(e) => setExportFilter('IsPhStatus', e.value)} placeholder="PH Status" showClear className="p-w-100" />
                            <Dropdown value={exportFilters.PhCategoryId} options={phCategoryOptions} onChange={(e) => setExportFilter('PhCategoryId', e.value)} placeholder="PH Category" showClear filter className="p-w-100" />
                            <Dropdown value={exportFilters.IsTFW} options={EXPORT_YESNO_OPTIONS} onChange={(e) => setExportFilter('IsTFW', e.value)} placeholder="TFW" showClear className="p-w-100" />
                            <Dropdown value={exportFilters.BloodGroup} options={bloodOptions} onChange={(e) => setExportFilter('BloodGroup', e.value)} placeholder="Blood Group" showClear filter className="p-w-100" />
                        </div>
                    </div>
                    <div className="p-d-flex p-ai-center p-jc-between" style={{ marginBottom: '10px' }}>
                        <label className="p-d-flex p-ai-center" style={{ gap: '8px', fontWeight: 600, cursor: 'pointer' }}>
                            <Checkbox
                                inputId="export-select-all"
                                checked={exportFields.length === STUDENT_EXPORT_FIELDS.length}
                                onChange={(e) => toggleAllExportFields(e.checked)}
                            />
                            Select All Fields
                        </label>
                        <span style={{ fontSize: '13px', color: '#6B7794' }}>{exportFields.length} selected</span>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', maxHeight: '340px', overflowY: 'auto' }}>
                        {STUDENT_EXPORT_FIELDS.map((f) => (
                            <label key={f.key} className="p-d-flex p-ai-center" style={{ gap: '8px', cursor: 'pointer' }}>
                                <Checkbox
                                    inputId={`export-field-${f.key}`}
                                    checked={exportFields.includes(f.key)}
                                    onChange={() => toggleExportField(f.key)}
                                />
                                <span style={{ fontSize: '13px' }}>{f.label}</span>
                            </label>
                        ))}
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default StudentMaster;
